import type { BankAccountType } from '../services/bankAccounts.service';

/**
 * The account number the server is sent. A US account is the routing number and the account
 * number: the server stores them as `routing-account`, the one form it encrypts, hashes and
 * compares with the account a bank statement reports. Every other type is one number.
 */
export function accountNumberForServer(
  accountType: BankAccountType,
  accountNumber: string,
  routingNumber: string,
): string {
  if (accountType !== 'ABA') return accountNumber.trim();
  return `${routingNumber.trim()}-${accountNumber.trim()}`;
}
